/**
 * PlayerAvatar — small rounded avatar with fallback chain:
 *   1) Transfermarkt headshot (clean face)
 *   2) PES DB card image, cropped to head area
 *   3) Gray placeholder with first letter
 *
 * Designed for compact rows (32–48px) but scales via the `size` prop.
 */
export default function PlayerAvatar({
    tmImage,
    pesImage,
    name = "",
    size = 32,
    testId,
}) {
    const initial = (name || "?").trim().charAt(0).toUpperCase();
    const dim = { width: `${size}px`, height: `${size}px` };

    if (tmImage) {
        return (
            <div
                className="shrink-0 rounded-full overflow-hidden bg-t1a1d24 border border-t22252a"
                style={dim}
                data-testid={testId}
            >
                <img
                    src={tmImage}
                    alt={name}
                    className="w-full h-full object-cover"
                    style={{ objectPosition: "center 20%" }}
                    loading="lazy"
                />
            </div>
        );
    }

    if (pesImage) {
        // PES DB card includes full body. Crop to head using object-position + scale.
        return (
            <div
                className="shrink-0 rounded-full overflow-hidden bg-t1a1d24 border border-t22252a"
                style={dim}
                data-testid={testId}
            >
                <img
                    src={pesImage}
                    alt={name}
                    className="w-full h-full object-cover"
                    style={{
                        objectPosition: "center 20%",
                        transform: "scale(1.8) translateY(8%)",
                    }}
                    loading="lazy"
                />
            </div>
        );
    }

    return (
        <div
            className="shrink-0 rounded-full bg-t22252a border border-t22252a flex items-center justify-center"
            style={dim}
            data-testid={testId}
        >
            <span className="op-mono text-t8f95a3 font-bold" style={{ fontSize: `${size * 0.4}px` }}>
                {initial}
            </span>
        </div>
    );
}
